/**
 * The last few failed API calls, attached to "Report a problem" so support can see what broke.
 * Only method, path (ids masked), status and time — never request or response bodies.
 */
const MAX = 10;
const errors: string[] = [];

const maskIds = (path: string) =>
  path
    .split('?')[0]
    .replace(/\/[0-9a-f]{24}(?=\/|$)/gi, '/:id')
    .replace(/\/[0-9a-f-]{36}(?=\/|$)/gi, '/:id')
    .replace(/\/my\/[A-Za-z0-9_-]{20,}/, '/my/:token');

export const recordApiError = (error: any) => {
  const config = error?.config;
  if (!config?.url) return;
  const status = error?.response?.status ?? 'network';
  const path = maskIds(String(config.url).replace(/^https?:\/\/[^/]+/, ''));
  const time = new Date().toTimeString().slice(0, 5);
  errors.push(`${String(config.method || 'get').toUpperCase()} ${path} → ${status} (${time})`);
  if (errors.length > MAX) errors.shift();
};

export const recentApiErrors = () => [...errors];
